import buttons from './buttons';
import errors from './errors';
import phones from './phones';
import emails from './emails';

const globalMessages = {
    buttons,
    errors,
    phones,
    emails,
};

export default globalMessages;
